const comments = [
  {
    name: '光影行者',
    text: '午马影院真的太良心了！不用注册直接就能看高清，播放速度也快，追《黑暗荣耀》全集一口气看完，完全不卡顿。已经推荐给身边所有朋友了！',
    time: '2026-07-30',
    rating: 5,
  },
  {
    name: '电影迷小王',
    text: '画质和流畅度真的没话说，切换清晰度也很方便。关键是更新速度特别快，《流浪地球3》预告片刚出就有了高清版，太给力了！',
    time: '2026-07-29',
    rating: 5,
  },
  {
    name: '追剧达人Emily',
    text: '一直想找一个不用下载APP、不用注册就能在线看的影视站，午马影院完美满足了我的需求。手机上看也很流畅，投屏到电视上画质也清晰。',
    time: '2026-07-28',
    rating: 5,
  },
  {
    name: '老影迷阿强',
    text: '作为一个看了二十多年电影的老影迷，午马影院的片库确实够全。连一些冷门的老片子都能找到高清修复版，这点必须点赞！专题合集分类也很清晰。',
    time: '2026-07-27',
    rating: 4,
  },
];

export default function Comments() {
  return (
    <section id="comments" className="w-full py-14 md:py-18 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="mb-8 text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            观众热评
          </h2>
          <p className="text-foreground-600 text-sm mt-2">来自真实用户的观影反馈，口碑见证品质</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {comments.map((comment, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl p-5 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-primary-600 font-heading font-bold text-sm">
                  {comment.name.charAt(0)}
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-500">{comment.time}</div>
                </div>
                <div className="ml-auto flex items-center gap-0.5">
                  {Array.from({ length: 5 }).map((_, j) => (
                    <span
                      key={j}
                      className={`w-4 h-4 flex items-center justify-center text-xs ${
                        j < comment.rating ? 'text-primary-500' : 'text-foreground-300'
                      }`}
                    >
                      <i className={j < comment.rating ? 'ri-star-fill' : 'ri-star-line'}></i>
                    </span>
                  ))}
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}